import { lazy } from 'react';
import Loadable from 'core/components/Loadable';

import { LAYOUT_BODEGA } from '../core/constants';
import * as constants from 'store/entities/constants';

const Dashboard = Loadable(lazy(() => import('views/b2b/bodegas/Dashboard')));
const Tramites = Loadable(lazy(() => import('views/b2b/bodegas/Tramites')));
const NotFound = Loadable(lazy(() => import('entorno/notfound')));
const ReportView = Loadable(lazy(() => import('reports')));
const FormView = Loadable(lazy(() => import('reports/components/Report')));

export const bodegaRoutes = (layouts, auth) => [
    {
        path: '/Report/:Report',
        element: <ReportView />
    },
    {
        path: '/form/:form',
        element: <FormView />
    },
    {
        path: '/',
        element: layouts[LAYOUT_BODEGA],
        children: [
            {
                path: '/',
                element: <Dashboard />
            },
            {
                path: '/b2b/bodegas/dashboard',
                element: <Dashboard />
            },
            {
                path: '/b2b/bodegas/tramites',
                element: <Tramites bodega={auth.user.bodega.id} />
            }
        ]
    },
    { path: '*', element: <NotFound /> }
];
